import { useContext } from "react";
import { Link } from "react-router-dom";
import { Context } from "../../context/Context";
import "./topbar.css";

export default function TopBar() {
  const { user, dispatch } = useContext(Context);
  const PF = "https://blog-app-o81u.onrender.com/images/"

  function Fb() {
    window.location.href = "https://www.facebook.com/profile.php?id=100018630789780";
 }

 function Twi() {
  window.location.href = "https://twitter.com/Deepak25326607";
}

function Insta() {
  window.location.href = "https://www.instagram.com/kr_deepak25/";
}

function git() {
  window.location.href = "https://github.com/Deepak931014";
}

function portfolio() {
  window.location.href = "https://deepak-portfolio-website.netlify.app/";
}

function weather() {
  window.location.href = "https://wetherappdeepak.herokuapp.com/";
}

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
  };
  return (
    <div className="top">
      <div className="topLeft">
        <i className="topIcon fab fa-facebook-square" onClick={Fb}></i>
        <i className="topIcon fab fa-twitter-square" onClick={Twi}></i>
        <i className="topIcon fab fa-github-square" onClick={git}></i>
        <i className="topIcon fab fa-instagram-square" onClick={Insta}></i>
      </div>
      <div className="topCenter">
        <ul className="topList">
          <li className="topListItem">
            <Link className="link" to="/">
              HOME
            </Link>
          </li>
          <li className="topListItem" onClick={weather}>
          <Link className="link" to="/">
             WEATHER
            </Link>
            </li>
          <li className="topListItem" onClick={portfolio}>
            <Link className="link" to="/">
              CONTACT
            </Link>
          </li>
          <li className="topListItem">
            <Link className="link" to="/write">
              WRITE
            </Link>
            </li>
          <li className="topListItem" onClick={handleLogout}>
            {user && "LOGOUT"}
          </li>
        </ul>
      </div>
      <div className="Right">
        {user ? (
          <Link to="/settings">
            <img className="topImg" src={PF+user.profilePic} alt="" />
          </Link>
        ) : (
          <ul className="topList">
            <li className="topListItem">
              <Link className="link" to="/login">
                LOGIN
              </Link>
            </li>
            <li className="topListItem">
              <Link className="link" to="/register">
                REGISTER
              </Link>
            </li>
         
          </ul>
        )}
      </div>
    
      <hr/>
    </div>
  );
}
